import React from 'react'
import { subscribe } from 'react-contextual'
import SupportStaffProvider from '../../SupportStaffProvider'

interface SupportStaffButtonProps {
  openAgencySelectionModal: () => void
}

const SupportStaffButton = ({ openAgencySelectionModal }: SupportStaffButtonProps) => {
  return (
    <button id="support-staff-button" onClick={openAgencySelectionModal}>
      Switch agency
    </button>
  )
}

export default subscribe([SupportStaffProvider], ({ openAgencySelectionModal }: SupportStaffButtonProps) => ({
  openAgencySelectionModal,
}))(SupportStaffButton)
